import styled from 'styled-components';

export const OfferingsWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
  padding:120px 0px 80px;
	position: relative;
	background-color: #fff;
  ${down(breakpoints.md)} {
    padding:50px 16px;
}
`
);

export const ContentHeaderText = styled.p(
	({ theme: { down, breakpoints } }) => `
  font-size:32px;
  font-weight:900;
  color:#9B9B9B;

  :first-letter {
      font-size:150px;
      color:#3B385E;
    }
  ${down(breakpoints.md)} {
    :first-letter {
      font-size:90px;
    }
  }
`
);

export const SubOfferItem = styled.li(
	({ theme: { down, breakpoints } }) => `

  width: 100%;
  border: 1px solid #d7d7d7;
  margin-bottom: 10px;
  border-radius: 2px;
  font-size: 16px;
  padding: 16px;
  ${down(breakpoints.md)} {
    padding: 8px 16px;
  }
`
);

export const OfferingsItem = styled.li(
	({ theme: { down, breakpoints } }) => `
  width:25%;
  margin-right:20px;
  &:last-child{
    margin-right: 0;
  }
  &:hover ${ContentHeaderText}{
    color: #FF664B;
    :first-letter {
      color:#FF664B;
    }
  }
  &:hover ${SubOfferItem}{
    border: 1px solid #ff664b;
    background: #FFFCFC;
    box-shadow: 0px 4px 32px rgba(0, 0, 0, 0.08);
  }

  ${down(breakpoints.md)} {
    width: 100%;
  }
  >p{
    min-height: 68px;
  }
`
);

export const OfferList = styled.ul`
	display: flex;
	flex-direction: ${(props) => props.dir ? props.dir : 'row'};
`;
